import _ from 'lodash';
import * as React from 'react';

// Used to check if data is clean to inform the user they do not have anything to submit
// ex: private partialCleanCheck: PartialCleanCheck<state> = new PartialCleanCheck(this, ['key']);
export default class PartialCleanCheck<S> {
  private oldFormData: Partial<S>;
  public constructor(private component: React.Component, private readonly keys: Array<keyof S>, private modifyOnCompare?: (modify: Partial<S>) => Partial<S>) {
    this.component = component;
    this.keys = keys;
    this.modifyOnCompare = modifyOnCompare;
  }

  // set old form data and only use the keys made in constructor
  /* ex:
      this.setState(prevState => {
        const newState = {};
        this.partialCleanCheck.setOldFormData(newState);
        return newState
      });
  */
  public readonly setOldFormData = (formState: Partial<S>): void => {
    this.oldFormData = _.pick(formState, this.keys);
  }
  // call this to check if formIsClean
  // does a deep check because form data can have lists
  // ex: this.partialCleanCheck.isClean()
  public readonly isClean = () => {
    if (this.modifyOnCompare !== undefined) {
      return _.isEqual(this.modifyOnCompare(this.oldFormData), _.pick(this.modifyOnCompare(this.component.state), this.keys));
    }
    return _.isEqual(this.oldFormData, _.pick(this.component.state, this.keys))
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/PartialCleanCheck.ts